const getClasseCnaeFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  {
    name: 'grupo_cnae',
    label: 'Grupo CNAE',
    type: 'select',
    options: drops?.GrupoCnae,
    multiple: true,
  },
  { name: 'codigo', label: 'Código' },
];

export default getClasseCnaeFilterFields;
